// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"cb3cef16","513":"35fa7ae7","703":"b02ef778"}[chunkId] + ".chunk.js";
};